import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {CoreCommonModule} from '@core/common.module';
import {TranslocoDirective} from '@jsverse/transloco';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {EffectsModule} from '@ngrx/effects';
import {StoreModule} from '@ngrx/store';
import {SharedModule} from 'app/main/shared/shared/shared.module';
import {NgScrollbarModule} from 'ngx-scrollbar';
import {AbouttoexpirewidgetComponent} from './abouttoexpirewidget/abouttoexpirewidget.component';
import {AutorenewalonwidgetComponent} from './autorenewalonwidget/autorenewalonwidget.component';
import {ContractcontrolwidgetComponent} from './contractcontrolwidget/contractcontrolwidget.component';
import {DashboardCustomizerSidebarComponent} from './dashboard-customizer-sidebar/dashboard-customizer-sidebar.component';
import {EmailbouncedwidgetComponent} from './emailbouncedwidget/emailbouncedwidget.component';
import {ExpiresonwidgetComponent} from './expiresonwidget/expiresonwidget.component';
import {ExtractDateDifferencePipe} from './extract-date-difference.pipe';
import {ForgottendocumentwidgetComponent} from './forgottendocumentwidget/forgottendocumentwidget.component';
import {LastsigneddocumentwidgetComponent} from './lastsigneddocumentwidget/lastsigneddocumentwidget.component';
import {LatestactivitywidgetComponent} from './latestactivitywidget/latestactivitywidget.component';
import {MostactiveuserswidgetComponent} from './mostactiveuserswidget/mostactiveuserswidget.component';
import {MostusedtemplateswidgetComponent} from './mostusedtemplateswidget/mostusedtemplateswidget.component';
import {DashboardFeatureKey} from './store/dashboard.config';
import {DashboardEffects} from './store/dashboard.effects';
import {dashboardReducer} from './store/dashboard.reducer';
import {TaskandreminderswidgetComponent} from './taskandreminderswidget/taskandreminderswidget.component';
import {TodoStatusBadgePipe} from './taskandreminderswidget/todo-status-badge.pipe';
import {UnreadchatmessagewidgetComponent} from './unreadchatmessagewidget/unreadchatmessagewidget.component';
import {UploaddocumentwidgetComponent} from './uploaddocumentwidget/uploaddocumentwidget.component';
import { MomentPipe } from 'app/pipes/moment.pipe';
import { UserTimeZoneFormatPipe } from 'app/pipes/user-timezone-format.pipe';


@NgModule({
  declarations: [
    UploaddocumentwidgetComponent,
    LatestactivitywidgetComponent,
    TaskandreminderswidgetComponent,
    AutorenewalonwidgetComponent,
    ExpiresonwidgetComponent,
    ContractcontrolwidgetComponent,
    ForgottendocumentwidgetComponent,
    LastsigneddocumentwidgetComponent,
    MostactiveuserswidgetComponent,
    UnreadchatmessagewidgetComponent,
    AbouttoexpirewidgetComponent,
    EmailbouncedwidgetComponent,
    MostusedtemplateswidgetComponent,
    ExtractDateDifferencePipe,
    TodoStatusBadgePipe,
    DashboardCustomizerSidebarComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    CoreCommonModule,
    NgbModule,
    NgScrollbarModule,
    StoreModule.forFeature(DashboardFeatureKey, dashboardReducer),
    EffectsModule.forFeature([DashboardEffects]),
    TranslocoDirective,
    RouterModule,
    MomentPipe,
    UserTimeZoneFormatPipe
  ],
  exports: [
    UploaddocumentwidgetComponent,
    LatestactivitywidgetComponent,
    TaskandreminderswidgetComponent,
    AutorenewalonwidgetComponent,
    ExpiresonwidgetComponent,
    ContractcontrolwidgetComponent,
    ForgottendocumentwidgetComponent,
    LastsigneddocumentwidgetComponent,
    MostactiveuserswidgetComponent,
    UnreadchatmessagewidgetComponent,
    AbouttoexpirewidgetComponent,
    EmailbouncedwidgetComponent,
    MostusedtemplateswidgetComponent,
    ExtractDateDifferencePipe,
    TodoStatusBadgePipe,
    DashboardCustomizerSidebarComponent
  ]
})
export class DashboardModule {}
